import React from "react";
import { Badge } from "react-bootstrap";

export const DATA_ADMISSION = [
    {
        label: "SOLICITANTE",
        value: "SOLICITANTE",
        color: "Orange",
        hexaDecimalColor: "#FF5733",
    },
];

export const DATA_LOWS = [
    {
        label: "BAJA DEFINITIVA",
        value: "BAJA DEFINITIVA",
        color: "Red",
        hexaDecimalColor: "#C70039",
    },
    {
        label: "BAJA TEMPORAL",
        value: "BAJA TEMPORAL",
        color: "Red",
        hexaDecimalColor: "#C70039",
    },
    {
        label: "BAJA ACADEMICA",
        value: "BAJA ACADEMICA",
        color: "Red",
        hexaDecimalColor: "#C70039",
    },
    {
        label: "BAJA POR ADEUDO",
        value: "BAJA POR ADEUDO",
        color: "Red",
        hexaDecimalColor: "#C70039",
    },
    {
        label: "BAJA INFORMAL",
        value: "BAJA INFORMAL",
        color: "Red",
        hexaDecimalColor: "#C70039",
    },
    {
        label: "BAJA POR DOCUMENTOS",
        value: "BAJA POR DOCUMENTOS",
        color: "Red",
        hexaDecimalColor: "#C70039",
    },
];

export const DATA_NORMAL = [
    {
        label: "PENDIENTE DE INGRESO",
        value: "PENDIENTE DE INGRESO",
        color: "Green",
        hexaDecimalColor: "#58D68D",
    },
    {
        label: "NORMAL",
        value: "NORMAL",
        color: "Green",
        hexaDecimalColor: "#58D68D",
    },
    {
        label: "PASANTE",
        value: "PASANTE",
        color: "Green",
        hexaDecimalColor: "#58D68D",
    },
    {
        label: "INTERNO",
        value: "INTERNO",
        color: "Green",
        hexaDecimalColor: "#58D68D",
    },
];

export const DATA_POSTEROR = [
    {
        label: "GRADUADO",
        value: "GRADUADO",
        color: "Blue",
        hexaDecimalColor: "#3FA6EA",
    },
    // {
    //     label: "TITULADO",
    //     value: "TITULADO",
    //     color: "Blue",
    //     hexaDecimalColor: "#3FA6EA",
    // },
    {
        label: "EGRESADO",
        value: "EGRESADO",
        color: "Blue",
        hexaDecimalColor: "#3FA6EA",
    },
    // ,
    // {
    //     label: "SERVICIO SOCIAL",
    //     value: "SERVICIO SOCIAL",
    //     color: "Blue",
    //     hexaDecimalColor: "#3FA6EA",
    // },
];

export const DATA = [
    ...DATA_ADMISSION,
    ...DATA_NORMAL,
    ...DATA_POSTEROR,
    ...DATA_LOWS,
];

export const filterStatusStudent = [
    ...DATA_NORMAL,
    ...DATA_POSTEROR,
    ...DATA_LOWS,
];

export const filterStatusAdmission = [...DATA_ADMISSION];

export const DATA_DEFINITION_INDEX = {
    SOLICITANTE:
        "Prospecto que aún no concluye el proceso de inscripción, quedando pendiente alguno de los procesos (firma de formato, pago o entrega de documentos).",

    NORMAL: "Estudiante que se encuentra activo con su documentación en orden.",

    PASANTE:
        "Estudiante activo que aún no ha concluido la totalidad de sus materias o créditos académicos, pero cuenta con la autorización institucional para realizar pasantías o prácticas profesionales en una institución externa como parte de su formación.",

    INTERNO:
        "Estudiante activo que aún no ha concluido la totalidad de sus materias o créditos académicos, pero cuenta con la autorización institucional para realizar su internado dentro de la propia institución como parte de su formación profesional.",

    "PENDIENTE DE INGRESO":
        "Estudiante con documentación en orden pero está pendiente de formalizar su inscripción para el próximo ciclo escolar.",

    DUPLICADO:
        "Nombre del estudiante o Matrícula duplicada, por lo tanto al existir un perfil con estatus de duplicado necesariamente deberá existir un perfil con otro estatus.",

    GRADUADO:
        "Estudiante que ha concluido el total de sus créditos/materias y ya realizo su proceso de titulación.",

    EGRESADO:
        "Estudiante que ha concluido el total de sus créditos/materias, pero que aún no se ha titulado.",

    "BAJA DEFINITIVA":
        "Baja formal, solicitada por el estudiante y que tiene como característica principal la suspensión definitiva de los estudios y el retiro de la documentación oficial, cancelando de inmediato las condiciones de inscripción inicial (becas, costos, condiciones especiales, etc.) Otras causas de BAJA DEFINITIVA pueden ser las siguientes: El acúmulo de bajas temporales por un lapso mayor a 2 años o agotar el máximo de oportuunidades para acreditar una asignatura (4 oportunidades para acreditar las máterias teóricas y 3 oportunidades para acreditar las materias prácticas).",

    "BAJA TEMPORAL":
        "Baja formal, solicitada por el estudiante y que tiene como característica principal la suspensión parcial de los estudios (y el retiro de la documentación oficial, cancelando de inmediato las condiciones de inscripción inicial (becas, costos, condiciones especiales, etc.).",

    "BAJA ACADEMICA":
        "Baja formal, solicitada por el Coordinador/Director por alguna de las siguientes causas: acumular más de 14 extraordinarios (para medicina el límite es de 10 extraordinarios) o contar con 4 materias o más reprobadas despues de los exámenes extraordinarios.",

    "BAJA POR ADEUDO":
        "Baja formal, solicitada por el Director de Finanzas debido a que se rebazó el limite permitido de adeudo económico.",

    "BAJA POR DOCUMENTOS":
        "Baja formal, solicitada por el Director de control Escolar debido a que se venció la fecha limite permitida para la entrega de documentos.",

    "BAJA INFORMAL":
        "Baja no oficial, solicitada por el Coordinador/Director de carrera debido a que el estudiante dejó de asistir a clase sin avisar y/o mencionando que su ausencia se debe a que pretende darse de baja (temporal o definitiva) pero no ha realizado el trámite administrativo correspondiente.",
};

export const DATA_DEFINITION = Object.entries(DATA_DEFINITION_INDEX).map(
    ([status, definition]) => ({
        status,
        definition,
    })
);

export const CATEGORIES_LOWS = [
    "Económicos",
    "Personal",
    "Salud",
    "Laboral",
    "Académicos",
    "Descontento con el campus",
    "Cambio de residencia",
    "Familiar",
    "No se presento",
    "No se puede contactar",
    "Listas UCG",
    "Falta de tiempo",
    "Incompatibilidad de horarios",
    "Cambio de institución",
    "Maternidad/Paternidad",
    "Problemas emocionales",
    "Falta de interés",
    "Fallecimiento",
    "Trámite migratorio",
    "Oferta académica insuficiente",
    "Modelo educativo no compatible",
    "Carga académica excesiva",
    "Otro",
];

export const OptionsDebtorDocuments = [
    {
        label: "Sí",
        value: 1,
    },
    {
        label: "No",
        value: 0,
    },
];

export const getAcademicRecordStatusBadge = (status) => {
    switch (status) {
        case "PENDIENTE":
            return (
                <Badge className="rounded border-warning bg-warning-subtle text-warning">
                    {status}
                </Badge>
            );
        case "ACEPTADO":
            return (
                <Badge className="rounded border-success bg-success-subtle text-success">
                    {status}
                </Badge>
            );
        case "RECHAZADO":
            return (
                <Badge className="rounded border-danger bg-danger-subtle text-danger">
                    {status}
                </Badge>
            );
        default:
            return (
                <Badge className="rounded border-secondary bg-secondary-subtle text-secondary">
                    Desconocido
                </Badge>
            );
    }
};
